import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import Forecast from "./Forecast";
import axios from "axios";
import "./Weather.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  const [unit, setUnit] = React.useState("fahr");

  const setFahr = () => setUnit("fahr");
  const setCels = () => setUnit("cels");

  function handleResponse(response) {
    setWeatherData({
      temp: response.data.main.temp,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      wind: response.data.wind.speed,
      city: response.data.name,
      country: response.data.sys.country,
      icon: response.data.weather[0].icon,
      description: response.data.weather[0].description,
      ready: true,
    });
  }

  function search() {
    const apiKey = "bc234aab8bbb2968177962751d16dea0";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form>
          <input
            type="search"
            placeholder="Enter city"
            onChange={(event) => {
              event.preventDefault();
              setCity(event.target.value);
            }}
          />
          <button
            onClick={(event) => {
              event.preventDefault();
              search();
            }}
          >
            Search
          </button>
        </form>
        <WeatherInfo
          data={weatherData}
          setFahr={setFahr}
          setCels={setCels}
          unit={unit}
        />
        <Forecast city={city} unit={unit} />
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
